<template lang="pug">
.row
  .col-12
    .table-responsive.mb-3
      table.table.table-sm.table-bordered.table-striped.table-hover
        thead.thead-light
          tr
            th
              div {{ $t("ui.theme") }}
        tbody
          tr
            td
              .color-wrapper#colorWrapper
                .col-full.order-setting
                  .col-full-content
                    .mt-3
                      DisplayLayoutBox(:imageURL="siteDetails.site[0].theme_code + '/' + siteDetails.site[0].theme_color")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import DisplayLayoutBox from '@/components/siteeditor/DisplayLayoutBox.vue'

export default {
  components: {
    DisplayLayoutBox
  },
  props: {
    siteId: {
      type: Number
    },
    siteDetails: {
      type: Object
    },
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    }
  },
  mounted: function() {},
  methods: {}
};
</script>